/**
 * Adjusts two percentage positions to prevent label overlap.
 * Extracted verbatim from price-scale.tsx — DO NOT change logic.
 */
export function calculateAdjustments(x: number, y: number, dist = 7): [number, number] {
  const originalX = x;
  const originalY = y;

  x = Math.max(dist, Math.min(100 - dist, x));
  y = Math.max(dist, Math.min(100 - dist, y));

  if (Math.abs(x - y) < dist) {
    if (x < y) {
      x = Math.max(dist, y - dist);
    } else {
      y = Math.max(dist, x - dist);
    }
  }

  return [x - originalX, y - originalY];
}

/**
 * Calculates the percentage position of current within [min, max].
 * Guards against division by zero when min === max.
 */
export function calculatePercent(current: number, min: number, max: number): number {
  if (max === min) return 0;
  return ((current - min) / (max - min)) * 100;
}

export function clampPercent(value: number): number {
  return Math.max(0, Math.min(100, value));
}
